import script from "./BrandListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandListPage.vue?vue&type=script&setup=true&lang=js"

import "./BrandListPage.vue?vue&type=style&index=0&id=9881cdbc&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9881cdbc"]])

export default __exports__